import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import JsBarcode from 'jsbarcode';
import { CommonServices } from 'src/app/Services/common.service';
import { StorageService } from 'src/app/Services/storage.service';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { ApiService } from 'src/app/Services/api.service';
import { ExcelExportService } from 'src/app/Services/excel.service';

@Component({
  selector: 'g10-roster-dispatch-viewer',
  templateUrl: './roster-dispatch-viewer.component.html',
  styleUrls: ['./roster-dispatch-viewer.component.css']
})
export class RosterDispatchViewerComponent implements OnInit {


  // Form variables
  public filterForm: FormGroup;
  public filterFormSubmit: boolean = false;
  public todayDate: any = new Date();
  public matFormSize: string = '13px';
  public getTripDate: any = '';
  public tableData: any = [];
  public cols: any = [
    { key: '#', display: '#' },
    {
      key: 'etaStr', display: 'Start',
    },
    {
      key: 'empRefID', display: 'Employee ID',
      config: {
        isUppercase: true,
      },
      headerConfig:{ isDefault: true}
    },
    {
      key: 'empName', display: 'Employee name',headerConfig:{ isDefault: true},
      config: {
        isTruncate: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      }
    },
    { key: 'gender', display: 'Gender' },
    { key: 'shiftTime', display: 'Shift time',headerConfig:{ isDefault: true}, },
    {
      key: 'empAddress', display: 'Address',
      config: {
        isTruncate: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      }
    },
  ]
  public noDataFoundEnable: boolean = false;
  public currentDate: boolean = true;
  public showTable: boolean = true;

  public vehArrays: any = [];
  public shiftListArr: any = [];
  public vendorArr: any = [];
  public transArr: any = [];
  public excelData: any = [];
  public isGuest: boolean = false;

  //Table Variables 
  public headers: any = ['#','Employee ID', 'Name', 'Gender', 'Mobile', 'Driver name / Mobile', 'ETA', 'Area', 'Address'];
  // public tripSheetData: any = [
  //   {
  //     "orgID": "626d347f61dd2331e3c07b4f",
  //     "shiftTimeStr": "09:00",
  //     "transitMode": "Pickup",
  //     "tripDate": 1680307200000.0,
  //     "vehRegNo": "TN57AA0004",
  //     "branchInfo": {
  //       "name": "Chengalpet",
  //       "location": {
  //         "lat": 13.02994,
  //         "lng": 80.11016,
  //         "name": "1st St, 12, Othavaadai St, Srinivasa Nagar, Mangadu, Chennai, Tamil Nadu 600122, India"
  //       }
  //     },
  //     "driverInfo": {
  //       "name": "Dhil Raju",
  //       "number": 9962020798.0
  //     },
  //     "empInfo": [
  //       {
  //         "eta": 17.45,
  //         "etaStr": "17:45",
  //         "empRefID": "SH1234",
  //         "name": "shankar",
  //         "employeeID": null,
  //         "mobile": 9962020798.0,
  //         "address": "Perumal kovil street ,Velachery,Chennai",
  //         "project": "Developement",
  //         "gender": "Male",
  //         "location": {
  //           "lat": 12.45631,
  //           "lng": 80.12795,
  //           "name": "Golden Bay Resorts, East Coast Road, Cheyyur, Tamil Nadu 603305, India"
  //         }
  //       },
  //       {
  //         "eta": 17.45,
  //         "etaStr": "17:45",
  //         "empRefID": "SH1235",
  //         "name": "mathan",
  //         "employeeID": null,
  //         "mobile": 9962020798.0,
  //         "address": "Velachery",
  //         "project": "Developement",
  //         "gender": "Male",
  //         "location": {
  //           "lat": 12.45631,
  //           "lng": 80.12795,
  //           "name": "Golden Bay Resorts, East Coast Road, Cheyyur, Tamil Nadu 603305, India"
  //         },
  //         "isAssigned": false
  //       }
  //     ],
  //     "routeID": "63e21768ac5248c138360d16",
  //     "shiftTime": 9,
  //     "status": 1,
  //     "title": "Login",
  //     "tripEndTime": null,
  //     "tripStartTime": null,
  //     "tripsheetID": 12233
  //   },
  //   {
  //     "orgID": "626d347f61dd2331e3c07b4f",
  //     "shiftTimeStr": "09:00",
  //     "transitMode": "Drop",
  //     "tripDate": 1680307200000.0,
  //     "vehRegNo": "TN60SA1561",
  //     "branchInfo": {
  //       "name": "Taramani",
  //       "location": {
  //         "lat": 13.02994,
  //         "lng": 80.11016,
  //         "name": "IITMRP Taramani, Chennai, Tamil Nadu 600122, India"
  //       }
  //     },
  //     "driverInfo": {
  //       "name": "Bala",
  //       "number": 9962020798.0
  //     },
  //     "empInfo": [
  //       {
  //         "eta": 17.45,
  //         "etaStr": "12:00",
  //         "empRefID": "SH1561",
  //         "name": "Mathan",
  //         "employeeID": null,
  //         "mobile": 9962020798.0,
  //         "address": "Kasimedu",
  //         "project": "Developement",
  //         "gender": "Male",
  //         "location": {
  //           "lat": 12.45631,
  //           "lng": 80.12795,
  //           "name": "Golden Bay Resorts, East Coast Road, Cheyyur, Tamil Nadu 603305, India"
  //         }
  //       },
  //       {
  //         "eta": 17.45,
  //         "etaStr": "01:00",
  //         "empRefID": "SH0306",
  //         "name": "Raja",
  //         "employeeID": null,
  //         "mobile": 9962020798.0,
  //         "address": "Navalur",
  //         "project": "Developement",
  //         "gender": "Male",
  //         "location": {
  //           "lat": 12.45631,
  //           "lng": 80.12795,
  //           "name": "Golden Bay Resorts, East Coast Road, Cheyyur, Tamil Nadu 603305, India"
  //         },
  //         "isAssigned": false
  //       }
  //     ],
  //     "routeID": "63e21768ac5248c138360d16",
  //     "shiftTime": 9,
  //     "status": 1,
  //     "title": "Logout",
  //     "tripEndTime": null,
  //     "tripStartTime": null,
  //     "tripsheetID": 34567812
  //   }
  // ]
  public localStorage;

  constructor(
    private dateAdapter: DateAdapter<Date>,
    public com: CommonServices,
    public storage: StorageService,
    public api: ApiService,
    public excel: ExcelExportService
  ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
  }

  ngOnInit() {
    this.filterFormLoad();
    // setTimeout(() => {
    //   this.renderBarCode();
    // }, 2000)
    this.getRosterDetails({
      tripDate: new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime(),
      default: true,
    })
  }

  renderBarCode() {
    this.tableData.map((tripId: any) => {
      try {
        JsBarcode("#tripsheetID-" + tripId.tripsheetID, tripId.tripsheetID);
      }
      catch (err) {
        console.log(err)
      }
    })
  }

  // Form load
  filterFormLoad() {
    this.filterForm = new FormGroup({
      date: new FormControl(this.todayDate,),
      vehRegNo: new FormControl(''),
      transitMode: new FormControl(''),
      vendor: new FormControl(''),
      shiftTimeStr: new FormControl(''),
    })
    this.localStorage = this.storage.get('userInfo');
  }

  public getRegNumber: any = '';
  public gettime: any = '';
  public getVendors: any = '';
  public getTranMode: any = '';

  fieldChange(e: any, fieldType) {
    let value = e.value;
    if (fieldType == 'vehRegNo') {
      this.getRegNumber = value;
    }
    if (fieldType == 'vendor') {
      this.getVendors = value;
    }
    if (fieldType == 'shiftTimeStr') {
      this.gettime = value;
    }
    if (fieldType == 'transitMode') {
      this.getTranMode = value;
    }
  }


  public isEscort: boolean = false;
  public isAssigned: any = '';
  public responseData: any = [];
  public isEmployee:boolean=false;
  public getVendorName :any =''
  public getDriverName:any='';
  public getDriverNo:any='';
  public showNoData:Boolean=false;

  getRosterDetails(obj) {
    this.showNoData=false;
    this.tableData = [];
    this.responseData = [];
    this.vehArrays = [];
    this.shiftListArr = [];
    this.vendorArr = [];
    this.transArr = [];
    this.api.transportManagerRosterList(obj).then((res: any) => {
      if (res && res.status == 'success') {
        if (res && res['status'] && res['data'].length > 0) {
          this.tableData = res['data'];
          this.responseData = res['data'];
          this.tableData.map((everyObj: any) => {
            everyObj['comName'] = this.localStorage['orgName']; //set company Name
            // Get Driver Name 
            this.getDriverName = everyObj['driverInfo']['name'];
            this.getDriverNo = everyObj['driverInfo']['number']; 

            everyObj['empInfo'].map((emp: any) => {

              if (emp && emp['userType'] && emp['userType'] == "Guest") {
                this.isGuest = true;
              } else {
                this.isGuest = false;
              }
              if (emp && emp['userType'] && emp['userType'] == "Escort") {
                this.isEscort = true
              }
              else {
                this.isEscort = false
              }
              if (emp && emp['userType'] && emp['userType'] == "Employee") {
                this.isEmployee = true
              }
              else {
                this.isEmployee = false
              }
              if (emp['isAssigned']) {
                this.isAssigned = true;
              } else {
                this.isAssigned = false;
              }

            })
          })
          if (this.isAssigned && this.tableData.length > 0) {
            this.getVehiclesOnly(this.responseData);
            this.getShitTimeOnly(this.responseData);
            this.getVendersOnly(this.responseData);
            this.getTransitModes(this.responseData)
          }
          this.showTable = true;
          this.showNoData=true;
        }else{
          this.tableData = [];
        this.responseData = [];
        this.noDataFoundEnable = true;
        this.showNoData=true;
        }
      } else {
        this.tableData = [];
        this.responseData = [];
        this.noDataFoundEnable = true;
        this.showNoData=true;
      }
    }).catch((err) => {
      console.log(err);
    })
    if (this.tableData.length > 0) {
      this.currentDate = false;
      this.showTable = true;
    }
    if (this.tableData.length <= 0) {
      this.noDataFoundEnable = true;
    }
  }

  resetFilterForm(){
    this.filterForm.patchValue({
      vehRegNo: '',
      transitMode: '',
      vendor: '',
      shiftTimeStr: ''
    })
    this.getRosterDetails({
      tripDate: new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime(),
      default: true,
    })
  }

  getTransitModes(obj: any) {
    let transitArr = [];
    obj.map((transMod: any) => {
      transitArr.push(transMod['transitMode'])
    })
    if(transitArr.length > 0){
      this.transArr = this.removeDuplicates(transitArr);
    }
  }

  getVehiclesOnly(obj: any) {
    let vehicleArr = [];
    obj.map((veh: any) => {
      vehicleArr.push(veh['vehRegNo'])
    })
    if(vehicleArr.length > 0){
      this.vehArrays = this.removeDuplicates(vehicleArr);
    }
  }

  getShitTimeOnly(obj: any) {
    let shiftArr = [];
    obj.map((shift: any) => {
      shiftArr.push(shift['shiftTimeStr'])
    })
    if(shiftArr.length > 0){
      this.shiftListArr = this.removeDuplicates(shiftArr);
    }
  }
  getVendersOnly(obj: any) {
    let vendorsList = [];
    obj.map((ven: any) => {
      vendorsList.push(ven['vendor'])
    })
    if(vendorsList.length > 0){
      this.vendorArr = this.removeDuplicates(vendorsList);
      for(let i=0;i<this.vendorArr.length;i++){
        if(this.vendorArr[i] === null){
          this.vendorArr[i] ='--Temporary--';
          // this.getVendorName ='Temporary'
        }else{
          this.vendorArr[i] = this.vendorArr[i]
          // this.getVendorName = this.vendorArr[i]
        }
      }
    }
  }
  removeDuplicates(arr) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  }

  public checkError = (controlName: string, errorName: string) => {
    return this.filterForm.controls[controlName].hasError(errorName);
  }

  onSubmit() {
    this.filterFormSubmit = true;
    let isValid = this.filterForm.valid;

    if (isValid) {
      let obj = {}
      if (this.filterForm.value.date != '') obj['tripDate'] = new Date(new Date(this.filterForm.value.date).setHours(0, 0, 0, 0)).getTime();
      obj['default'] = true;
        this.getRosterDetails(obj)
    }

    this.showNoData=false;
    setTimeout(() => {
      if (this.getRegNumber != '') {
        this.responseData = this.responseData.filter(e => e['vehRegNo'] == this.getRegNumber)
      }
      if (this.getVendors != '') {
        if(this.getVendors=="--Temporary--"){
          this.getVendors = null;
        }
        this.responseData = this.responseData.filter(e => e['vendor'] == this.getVendors)
      }
      if (this.getTranMode != '') {
        this.responseData = this.responseData.filter(e => e['transitMode'] == this.getTranMode)
      }
      if (this.gettime != '') {
        this.responseData = this.responseData.filter(e => e['shiftTimeStr'] == this.gettime)
      }
      this.tableData = this.responseData
      this.showNoData=true;
    }, 1000)
  }

  downloadPDF() {

    const jsPdf = new jsPDF('p', 'pt', 'a4', true);
    html2canvas(document.getElementById('tripSheetCard')).then((canvas) => {
      let imgData = canvas.toDataURL(
        'image/png');
      let doc = new jsPDF('p', 'pt', 'a4', true);
      doc.addImage(imgData, 'PNG', 10, 10, 580, 300);
      doc.save('sample-file.pdf');
    });

    // jsPdf.html(document.getElementById('tripSheetCard'), {
    //   filename: 'TripSheet',
    //   callback: function (doc) {
    //     console.log(doc);
    //     doc.save('TripSheet');
    //   },
    //   html2canvas:{ scale : 0.38 },
    //   x:10,
    //   y:10,
    // });
  }

  // Excel download 
  public getCompanyName: any = '';
  public getVehNo: any = '';
  public getShiftTime: any = '';
  public getTransitMode: any = '';
  public addImg: any = '';
  public getDriverMobile : any='';
  public getDrivName:any=''
  async exportToExcel() {
    let rowCount = 2;
    let endCell = (this.isGuest || this.isEscort || this.isEmployee) ? 'K' : 'G';
    let customizedData = [];

    let titleRow = {
      value: ['Dispatch Viewer'],
      font: {
        name: 'Corbel', family: 4, size: 16, bold: true,
        color: { argb: 'FFFFFFFF' },
      },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      alignment: {
        cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '966462AF' },
        bgColor: { argb: 'FFF' }
      },
    }
    customizedData.push(titleRow);

    for (let i = 0; i < this.tableData.length; i++) {
      let item = this.tableData[i];

      this.getCompanyName = item['comName'];
      this.getVehNo = item['vehRegNo'];
      this.getShiftTime = item['shiftTimeStr'];
      this.getTransitMode = item['transitMode'];
      this.getVendorName =item['vendor'];
      this.getDrivName = item['driverInfo']['name']
      this.getDriverMobile = item['driverInfo']['number']

      this.getVendorName = (this.getVendorName === null) ? this.getVendorName = 'Temporary' : this.getVendorName;

      // SubTitleRow
      rowCount += 7; //7
      let subtitleRow = {
        value: [
          "Org Name                : " + this.com.convertTitleCase(item['comName']) + "\n" +
          "Trip Date                 : " + this.com.timestampToDate(new Date(this.filterForm.value.date).getTime(), 'DMY') + "\n" +
          "Reg No                     : " + String(item.vehRegNo).toUpperCase() + "\n" +
          "Transit Mode           : " + this.getTransitMode + "\n" +
          "Shift Time                : " + this.getShiftTime + "\n" +
          "Vendor                     : " + this.com.convertTitleCase(this.getVendorName) + "\n"+
          "Trip Sheet ID            : " + item['tripsheetID']
        ],
        // "Trip Sheet ID   : " + JsBarcode("#tripsheetID-" + item['tripsheetID'], item['tripsheetID'])
        // font: { name: 'Corbel', family: 4, size: 12, },
        font: { family: 4, size: 12 },
        border: {right: { style: 'thin' } },
        mergeCells: `A${(rowCount - 6) + ''}:${endCell + rowCount + ''}`,
      }
      // this.addImg.addImage({
      //   filename: JsBarcode("#tripsheetID-" + item['tripsheetID'], item['tripsheetID']),
      //   extension: 'png',
      // });
      customizedData.push(subtitleRow);


      if (this.tableData[i]['empInfo'] && this.tableData[i]['empInfo'].length > 0) {

        rowCount = rowCount + 1;//8
        let headerRow =
        {

          value: (this.isGuest || this.isEscort || this.isEmployee) ? ['S No', 'Employee ID', 'Employee name', 'User type', 'Gender', 'Driver name', 'Driver mobile','Shift time', 'ETA', 'Area','Address'] :
            ['S No', 'Employee ID', 'Employee name', 'Gender', 'Shift time', 'ETA', 'Address'],
          font: { bold: true, size: 12 },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
        }
        customizedData.push(headerRow);

        // Get Employees only
        for (let e = 0; e < item['empInfo'].length; e++) {
          rowCount += 1
          let data = item['empInfo'][e];
          try {
            let res = {
              value: (this.isGuest || this.isEscort || this.isEmployee) ? [
                e + 1,
                data.empRefID ? String(data.empRefID).toUpperCase() : '---',
                data.name ? String(data.name).charAt(0).toUpperCase() + String(data.name).slice(1).toLowerCase() : '---',
                data.userType ? this.com.convertTitleCase(data.userType) : '---',
                data.gender ? (data.gender == 'M') ?  'Male' : (data.gender == 'F') ? 'Female' :  (data.gender == 'T') ? 'Others' :  this.com.convertTitleCase(data.gender) : '---',
                this.getDrivName ? String(this.getDrivName).charAt(0).toUpperCase()+ String(this.getDrivName).slice(1).toLowerCase() :'---' , 
                this.getDriverMobile ? this.getDriverMobile : '---',
                this.getShiftTime ?  this.getShiftTime : '---',
                data.etaStr ? String(data.etaStr).toUpperCase() : '---',
                data.area ? String(data.area).charAt(0).toUpperCase() + String(data.area).slice(1).toLowerCase() : '---',
                data.address ? String(data.address).charAt(0).toUpperCase() + String(data.address).slice(1).toLowerCase() : '---',
              ] : [
                e + 1,
                data.empRefID ? String(data.empRefID).toUpperCase() : '---',
                data.name ? this.com.convertTitleCase(data.name) : '---',
                data.gender ? (data.gender == 'M') ?  'Male' : (data.gender == 'F') ? 'Female' :  (data.gender == 'T') ? 'Others' :  this.com.convertTitleCase(data.gender) : '---',
                this.getShiftTime ? this.getShiftTime : '---',
                data.etaStr ? String(data.etaStr).toUpperCase() : '---',
                data.address ? this.com.convertTitleCase(data.address) : '---',
              ],
              // border: {right: { style: 'thin' } },
            }
            customizedData.push(res);
          }
          catch (err) {
            console.log(err)
          }

        }

        rowCount += 1;
        let vehDivder = {
          value: [],
          mergeCells: `A${rowCount + ''}:${endCell + rowCount + ''}`,
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'DCDCDC' },
            bgColor: { argb: 'DCDCDC' }
          },
        }
        customizedData.push(vehDivder);
      }
    }

    let excelSheetName = 'Dispatch Viewer';
    if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }
    this.excelData[excelSheetName] = {
      customizedData: customizedData,
      data: {
        columWith: (this.isGuest || this.isEscort || this.isEmployee) ? [{ colNo: 2, width: 25 }, { colNo: 3, width: 25 }, { colNo: 4, width: 15 }, { colNo: 5, width: 15 }, { colNo: 6, width: 25 }, { colNo: 7, width: 20 }, { colNo: 8, width: 20 }, { colNo: 9, width: 20 },{ colNo: 10, width: 30 },{ colNo: 11, width: 50} ]
          : [{ colNo: 2, width: 25 }, { colNo: 3, width: 25 }, { colNo: 4, width: 15 }, { colNo: 5, width: 15 }, { colNo: 6, width: 20 }, { colNo: 7, width: 100 }, { colNo: 8, width: 15 }, { colNo: 9, width: 50 }]
      },
    };
    this.downloadExlReport();
  }

  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Dispatch-Viewer-Report' + new Date().getTime() + '.xlsx');
  }
}
